import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  Modal,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectMstaddresstype } from "../location/locationSlice";
import { ModalInspection } from "../filterModal/ModalInspection";
import { ModalDamageSelect } from "../filterModal/ModalDamageSelect";
import { v4 as uuidv4 } from "uuid";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },

  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModalInspectionCreate = ({
  isOpen,
  handleShow,
  setShow,
  setShowInspectionModal,
  showInspectionModal,
  setFields,
  fields,
  setShowDamageModal,
  showDamageModal,
  formValues,
  setFormValues,
  formDamage,
  setFormDamage,
  listInspectionPoint,
  setListInspectionPoint,
  dataRow,
  setDataRow,
  listDamage,
  setListDamage,
  formatExtraData,
  setFormatExtraData,
  setRowIndex,
  rowIndex,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (dataRow !== null) {
      setFormValues({
        inspectioncategory_id: {
          value: dataRow.inspectioncategory_id,
          error: false,
          required: "Y",
        },
        inspectioncategory_name: {
          value: dataRow.inspectioncategory_name,

          error: false,
          required: "Y",
        },
        point_inspection: {
          value: dataRow.point_inspection,

          error: false,
          required: "Y",
        },
      });

      if (dataRow.damageConditions === null) {
        setListDamage([]);
      } else {
        setListDamage(dataRow.damageConditions);
      }
    }
  }, [dataRow]);

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeDamage = (e) => {
    const { name, value } = e.target;
    setFormDamage({
      ...formDamage,
      [name]: {
        ...formDamage[name],
        value,
      },
    });
  };

  const handleChangeCountry = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
      ["country_name"]: {
        ...formValues["country_name"],
        value: label,
      },
    });
  };

  const handleChangeAddress = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["address_type"]: {
        ...formValues["address_type"],
        value,
      },
      ["address_name"]: {
        ...formValues["address_name"],
        value: label,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleClose = () => {
    setFormValues({
      inspectioncategory_id: {
        value: "",
        error: false,
        required: "Y",
      },
      inspectioncategory_name: {
        value: "",
        error: false,
        required: "N",
      },
      point_inspection: {
        value: "",
        error: false,
        required: "N",
      },
    });

    setFormDamage({
      damagecondition_id: {
        value: "",
        error: false,
        required: "Y",
      },
      damagecondition_name: {
        value: "",
        error: false,
        required: "Y",
      },
      max_weight: {
        value: "",
        error: false,
        required: "Y",
      },
    });

    setListDamage([]);
    setDataRow(null);
    setShow(false);
  };

  const validatePostDamage = (e) => {
    let isValid = true;

    const formFields = Object.keys(formDamage);
    let newFormValues = { ...formDamage };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formDamage[currentField].value;
      const required = formDamage[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormDamage(newFormValues);

    return isValid;
  };

  const handleAddDamage = () => {
    if (!validatePostDamage()) {
      return;
    }
    if (formDamage.max_weight.value > 100) {
      return showDialog("Cannot be greater than 100");
    }
    const params = {
      damagecondition_id: formDamage.damagecondition_id.value,
      damagecondition_name: formDamage.damagecondition_name.value,
      max_weight: formDamage.max_weight.value,
    };

    const isDuplicate = listDamage.some(
      (item) => item.damagecondition_id === params.damagecondition_id
    );

    if (isDuplicate) {
      showDialog("Damage can't be the same");
    } else {
      // Menambahkan newData ke dalam data jika tidak ada duplikat
      setListDamage([...listDamage, params]);
    }

    setFormDamage({
      damagecondition_id: {
        value: "",
        error: false,
        required: "Y",
      },
      damagecondition_name: {
        value: "",
        error: false,
        required: "Y",
      },
      max_weight: {
        value: "",
        error: false,
        required: "Y",
      },
    });
  };

  const handleDelete = (e, row, rowIndex, formatExtraData) => {
    const idColumn = row.damagecondition_id;
    const temp = [...formatExtraData];
    let items = temp.filter(
      (value, index) => value.damagecondition_id !== idColumn
    );
    setListDamage(items);
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
        >
          <div
            className="btn btn-icon btn-primary btn-hover-primary btn-sm"
            onClick={(e) => handleDelete(e, row, rowIndex, formatExtraData)}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
            </span>
          </div>
        </OverlayTrigger>
      </div>
    );
  };
  const columnsDamage = [
    {
      text: "Condition",
      dataField: "damagecondition_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Maximum Weight",
      dataField: "max_weight",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      formatExtraData: listDamage,
    },
  ];

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    if (listDamage.length < 1) {
      return showDialog("Please input Damage ");
    }

    const params = {
      id: uuidv4(),
      inspectioncategory_id: formValues.inspectioncategory_id.value,
      inspectioncategory_name: formValues.inspectioncategory_name.value,
      point_inspection: formValues.point_inspection.value,
      damageConditions: listDamage,
    };

    if (dataRow !== null) {
      const list = [...formatExtraData];

      list[rowIndex] = params;

      setListInspectionPoint(list);
    } else {
      setListInspectionPoint([...listInspectionPoint, params]);
    }

    handleClose();
  };

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            {dataRow === null ? "New" : "Edit"} Configure Inspection Points
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <p className="font-weight-bold  m-3">Inspection Point Details</p>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Row>
                  <Col xs={10} sm={3} md={9} lg={9}>
                    <RedditTextField
                      required
                      label="Inspection Category"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      readOnly
                      value={formValues.inspectioncategory_name.value}
                      error={formValues.inspectioncategory_name.error}
                      helperText={
                        formValues.inspectioncategory_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col>
                    <div>
                      <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                        <span
                          className="svg-icon svg-icon-md svg-icon-light"
                          onClick={() => setShowInspectionModal(true)}
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/New/Search.svg"
                            )}
                          />
                        </span>
                      </a>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <RedditTextField
                  required
                  label="Point of Inspection"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="point_inspection"
                  onChange={handleChange}
                  value={formValues.point_inspection.value}
                  error={formValues.point_inspection.error}
                  helperText={
                    formValues.point_inspection.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />
              </Col>
            </Row>
            <p className="font-weight-bold  m-3">Damage Condition</p>

            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Row>
                  <Col xs={10} sm={3} md={9} lg={9}>
                    <RedditTextField
                      required
                      label="Condition"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      readOnly
                      value={formDamage.damagecondition_name.value}
                      error={formDamage.damagecondition_name.error}
                      helperText={
                        formDamage.damagecondition_name.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col>
                    <div>
                      <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                        <span
                          className="svg-icon svg-icon-md svg-icon-light"
                          onClick={() => setShowDamageModal(true)}
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/New/Search.svg"
                            )}
                          />
                        </span>
                      </a>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={3} md={4} lg={4}>
                <RedditTextField
                  required
                  label="Maximum Weight"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="max_weight"
                  onChange={handleChangeDamage}
                  value={formDamage.max_weight.value}
                  error={formDamage.max_weight.error}
                  helperText={
                    formDamage.max_weight.error ? (
                      <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                        {iconError} {"This field is required"}
                      </FormHelperText>
                    ) : (
                      ""
                    )
                  }
                />
              </Col>
              <Col xs={12} sm={3} md={2} lg={2}>
                <Button
                  variant="outline-primary"
                  className="mt-4"
                  onClick={handleAddDamage}
                >
                  Add
                </Button>
              </Col>
            </Row>
          </ThemeProvider>

          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container mt-7"
            bootstrap4
            
            keyField="damagecondition_id"
            data={listDamage}
            columns={columnsDamage}
            hover
            striped
            headerClasses="header-class"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button onClick={handleSave} variant="primary">
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalInspection
        isOpen={showInspectionModal}
        setShow={setShowInspectionModal}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
      />
      <ModalDamageSelect
        isOpen={showDamageModal}
        setShow={setShowDamageModal}
        setFormValues={setFormDamage}
        formValues={formDamage}
        setFields={setFields}
        fields={fields}
      />
    </>
  );
};
